import { Text } from '@heathmont/moon-components';
import Translate from '~/client/shared/i18n/Translate';
import Stack from '~/client/shared/Stack';
import OptionsButton from './OptionsButton';
import ResendCodeButton from './ResendCodeButton';
import useEnterOtpStep from '../helpers/use2FAStep';
import useEnterSms2faStep from '../useEnterSms2faStep';
import ChatChat from '@/external/icons/ChatChat';

type Props = {
  isPopover?: boolean;
};

const MoreOptionsStep: FC<Props> = ({ isPopover }) => {
  const { handleResendCodeClick } = useEnterSms2faStep({ isPopover });
  const { handleOpenComms } = useEnterOtpStep();
  return (
    <Stack>
      <Text size={16} color="bulma.100">
        <Translate id="profile.options_continue" />
      </Text>
      <Text size={14} color="trunks.100">
        <Translate id="profile.notifications_turned_on" />
      </Text>
      <ResendCodeButton onResendCodeClick={handleResendCodeClick} />
      <OptionsButton
        translateId="profile.contact_support"
        onClick={handleOpenComms}
      >
        <ChatChat />
      </OptionsButton>
    </Stack>
  );
};

export default MoreOptionsStep;
